import React from 'react'
import './EmptyShop.css'

export const EmptyShop: React.FC = () => {
    return (
        <div className="empty-shop">
            <div className="empty-shop-content">
                <h1 className="empty-shop-title">Dropping Soon</h1>

                <p className="empty-shop-description">
                    We will be adding our intital launch products soon!
                </p>

                {/* <div className="empty-shop-actions">
                    <button
                        className="empty-shop-button"
                        onClick={() => window.location.reload()}
                    >
                        Refresh Page
                    </button>
                </div> */}

                {/* <div className="empty-shop-footer">
                    <p className="empty-shop-note">
                        Want to be the first to know about new products?
                        Follow us for updates and exclusive releases.
                    </p>
                </div> */}
            </div>
        </div>
    )
}
